import { FC } from 'react';
import { CloseWrapper, ConfirmContent, ConfirmText, ConfirmWrapper, FilledButton, HollowButton, SecondText } from './styles';
import { FlexBox } from '@brg/ui';
import { ExploreButtonFilled, ExploreButtonHollow } from 'shared/pages/explore/styles';
import { useTranslation } from 'react-i18next';
import { CloseModalIconMob } from 'core/modules/CloseIconNewMob';
import { API, Endpoints } from '@brg/api';


export const TemplateModal: FC<{ 
  mainText: string,
  confirmText: string,
  secondText: string,
  cancelText: string,
  onConfirm: () => void,
  onSecond: () => void 
}> = ({
  mainText,
  confirmText, 
  secondText,
  cancelText,
  onConfirm,
  onSecond 
}) => {
    const { t } = useTranslation();

    return (
        <ConfirmWrapper>
            <ConfirmContent>
                {/* <CloseWrapper>
                    <CloseModalIconMob onClick={onSecond}/>
                </CloseWrapper> */}
                <FlexBox direction='column' directionMobile='column' gy={8} gyMobile={8}>
                  <ConfirmText>{mainText}</ConfirmText>
                  <SecondText>{secondText}</SecondText>
                </FlexBox>
                <FlexBox 
                  width={'100%'} 
                  widthMobile={'100%'} 
                  gx={24} 
                  gxMobile={1} 
                  gyMobile={8} 
                  direction='row' 
                  directionMobile='column' 
                  offsetTop={24} 
                  justify='center'
                >
                    <HollowButton onClick={onSecond}>
                        {cancelText}
                    </HollowButton>
                    <FilledButton onClick={onConfirm}>
                        {confirmText}
                    </FilledButton>
            
                </FlexBox>
            </ConfirmContent>
        </ConfirmWrapper>
    )
}import { FC } from 'react';
import { CloseWrapper, ConfirmContent, ConfirmText, ConfirmWrapper, FilledButton, HollowButton, SecondText } from './styles';
import { FlexBox } from '@brg/ui';
import { ExploreButtonFilled, ExploreButtonHollow } from 'shared/pages/explore/styles';
import { useTranslation } from 'react-i18next';
import { CloseModalIconMob } from 'core/modules/CloseIconNewMob';
import { API, Endpoints } from '@brg/api';


export const TemplateModal: FC<{ 
  mainText: string,
  confirmText: string,
  secondText: string,
  cancelText: string,
  onConfirm: () => void,
  onSecond: () => void 
}> = ({
  mainText,
  confirmText, 
  secondText,
  cancelText,
  onConfirm,
  onSecond 
}) => {
    const { t } = useTranslation();

    return (
        <ConfirmWrapper>
            <ConfirmContent>
                {/* <CloseWrapper>
                    <CloseModalIconMob onClick={onSecond}/>
                </CloseWrapper> */}
                <FlexBox direction='column' directionMobile='column' gy={8} gyMobile={8}>
                  <ConfirmText>{mainText}</ConfirmText>
                  <SecondText>{secondText}</SecondText>
                </FlexBox>
                <FlexBox 
                  width={'100%'} 
                  widthMobile={'100%'} 
                  gx={24} 
                  gxMobile={1} 
                  gyMobile={8} 
                  direction='row' 
                  directionMobile='column' 
                  offsetTop={24} 
                  justify='center'
                >
                    <HollowButton onClick={onSecond}>
                        {cancelText}
                    </HollowButton>
                    <FilledButton onClick={onConfirm}>
                        {confirmText}
                    </FilledButton>
            
                </FlexBox>
            </ConfirmContent>
        </ConfirmWrapper>
    )
}